export const PopupActionTypes = {
  OPEN_POPUP: 'OPEN_POPUP',
  CLOSE_POPUP: 'CLOSE_POPUP',
  NEXT_BUTTON: 'NEXT_BUTTON',
}

export const openPopup = (id, data) => ({
  type: PopupActionTypes.OPEN_POPUP,
  id,
  data,
})

export const closePopup = id => ({
  type: PopupActionTypes.CLOSE_POPUP,
  id,
})

export const nextButton = (id, data) => ({
  type: PopupActionTypes.NEXT_BUTTON,
  id,
  data,
})
